import { getDecryptedToken } from "../crypto/cryptoUtils";

/**
 * Returns the currency symbol from localStorage, defaulting to "Rs." if not found
 */
export const getCurrencySymbol = (): string => {
  return getDecryptedToken("currency") || "Rs.";
};
